import Reveal from "../../components/ui/Reveal";
import styles from "./page.module.css";

// const partners = [
//   { name: "Toray Innovation",      logo: "https://infinity-et.com/wp-content/uploads/2025/04/IATS_Company_Profile_14.05.jpg" },
//   { name: "Schiller",              logo: "https://infinity-et.com/wp-content/uploads/2025/04/IATS_Company_Profile_14.05hsd.jpg" },
//   { name: "Radiometer",            logo: "https://infinity-et.com/wp-content/uploads/2025/04/images.png" },
//   { name: "STORZ Endoskope",       logo: "https://infinity-et.com/wp-content/uploads/2025/04/Karl_Storz_Endoskope_logo.svg.png" },
//   { name: "Leica Biosystems",      logo: "https://infinity-et.com/wp-content/uploads/2025/04/Leica_Biosystems_Logo.jpg" },
//   { name: "Carestream",            logo: "https://infinity-et.com/wp-content/uploads/2025/04/logo_master_brand_mark_hires.jpg" },
//   { name: "Sturdy Medical",        logo: "https://infinity-et.com/wp-content/uploads/2025/04/sturdy2-logo-300x113-1.png" },
//   { name: "Terumo",                logo: "https://infinity-et.com/wp-content/uploads/2025/04/Terumo.svg.png" },
//   { name: "Thermo Fisher",         logo: "https://infinity-et.com/wp-content/uploads/2025/04/Thermo_Fisher_Scientific_logo.svg.png" },
//   { name: "Oracle",                logo: "https://infinity-et.com/wp-content/uploads/2025/04/IMG_0006.png" },
// ];

// const stats = [
//   { number: "20+",  label: "Years of Experience",  icon: "📅" },
//   { number: "4000+",  label: "Facilities Served",    icon: "🏥" },
//   { number: "30+",  label: "Global Partners",      icon: "🤝" },
//   { number: "24/7", label: "Technical Support",    icon: "🔧" },
// ];

const values = [
  {
    title: "Consultation & Planning",
    desc: "We constantly seek cutting-edge solutions to address the evolving challenges of healthcare in Ethiopia & Kenya.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-journal-check" viewBox="0 0 16 16">
  <path fillRule="evenodd" d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
  <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"/>
  <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"/>
</svg>,
  },
  {
    title: "Facility Design Support",
    desc: "Our clients depend on us. We deliver on our promises with consistent, high-quality service.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-gear" viewBox="0 0 16 16">
  <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
  <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
</svg>,
  },
  {
    title: "Equipment Procurement",
    desc: "We build long-term relationships with healthcare providers, understanding their unique needs.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clipboard-check" viewBox="0 0 16 16">
  <path fillRule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
  <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
</svg>,
  },
  {
    title: "Delivery & Installation",
    desc: "We build long-term relationships with healthcare providers, understanding their unique needs.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-truck" viewBox="0 0 16 16">
  <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5zm1.294 7.456A2 2 0 0 1 4.732 11h5.536a2 2 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456M12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
</svg>,
  },
  {
    title: "Commissioning",
    desc: "We build long-term relationships with healthcare providers, understanding their unique needs.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-credit-card" viewBox="0 0 16 16">
  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z"/>
  <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/>
</svg>,
  },
  {
    title: "Technical Service",
    desc: "We build long-term relationships with healthcare providers, understanding their unique needs.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tools" viewBox="0 0 16 16">
  <path d="M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.27 3.27a.997.997 0 0 0 1.414 0l1.586-1.586a.997.997 0 0 0 0-1.414l-3.27-3.27a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3q0-.405-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814zm9.646 10.646a.5.5 0 0 1 .708 0l2.914 2.915a.5.5 0 0 1-.707.707l-2.915-2.914a.5.5 0 0 1 0-.708M3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026z"/>
</svg>,
  },
  {
    title: "Spare parts supply",
    desc: "We build long-term relationships with healthcare providers, understanding their unique needs.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-seam" viewBox="0 0 16 16">
  <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z"/>
</svg>,
  },
  {
    title: "Preventive Maintenance",
    desc: "We build long-term relationships with healthcare providers, understanding their unique needs.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-shield-shaded" viewBox="0 0 16 16">
  <path fillRule="evenodd" d="M8 14.933a1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"/>
</svg>,
  },
];

export const metadata = {
  title: "About Us",
  description:
    "Learn about Infinity's mission to transform healthcare in Ethiopia & Kenya through cutting-edge medical equipment, technical services, and lasting partnerships.",
};
export default function About() {

  return (
    <main>
      {/* ── Hero ──────────────────────────── */}
      <section className="pageHero">
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <Reveal>
            <span className="pageHeroLabel">About Us</span>
            <h1 className="pageHeroTitle">Healthcare Technology Expertise Built Over 18 Years</h1>
            <p className="pageHeroDesc">
              Infinity operates as a healthcare technology infrastructure partner in Ethiopia and Kenya, combining GE Healthcare equipment distribution, turnkey installation, lifecycle maintenance, spare parts, consumables, and clinical training into a single integrated platform.
            </p>
          </Reveal>
        </div>
      </section>
      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.missionGrid}>
            <Reveal direction="left">
              <div className={styles.missionText}>
                <span className={styles.label}></span>
                <h2 className={styles.h2}>Background</h2>
                <p>
                  Established in 2006, Infinity Advanced Technology Solutions has become one of East Africa&apos;s most trusted healthcare technology providers.
                </p>
                <p>
                  Operating from Ethiopia and Kenya, Infinity supports government hospitals, university medical centers, private healthcare institutions, NGOs, and specialty healthcare facilities.
                </p>
                <p>
                  Our approach extends beyond equipment distribution. We provide complete healthcare ecosystems that combine advanced medical technologies, infrastructure development, installation, technical services, and long-term operational support.
                </p>
                {/* <Link href="/contact" className={styles.btn}>Work With Us →</Link> */}
              </div>
            </Reveal>

            <Reveal direction="right">
              <div className={styles.missionimg}>
                <img src={'/images/partner.webp'}/>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      {/* ── Mission ───────────────────────── */}
      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.missionGrid}>
            <Reveal direction="left">
              <div className={styles.missionText}>
                <span className={styles.label}>Our Mission</span>
                <h2 className={styles.h2}>We&apos;re Here to Drive Progress</h2>
                <p>
                  To improve healthcare outcomes by delivering world-class medical technologies and integrated healthcare infrastructure solutions.
                </p>
                <p>
                  We understand that access to reliable, cutting-edge medical equipment is crucial
                  for delivering quality care and improving patient outcomes across East Africa.
                </p>
                {/* <Link href="/contact" className={styles.btn}>Work With Us →</Link> */}
              </div>
            </Reveal>

            <Reveal direction="right">
              <div className={styles.missionimg}>
                <img src={'/images/mission.webp'}/>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      {/* Vision */}
      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.missionGrid}>
            {/* <Reveal direction="left">
              <div className={styles.missionText}>
                <span className={styles.label}>Our Vision</span>
                <h2 className={styles.h2}>We're Here to Drive Progress</h2>
                <p>
                  To become Africa's leading healthcare technology and infrastructure partner.
                </p>
               
                
              </div>
            </Reveal> */}

            {/* <Reveal direction="right">
              <div className={styles.statsGrid}>
                {stats.map((s, i) => (
                  <div key={i} className={styles.statCard}>
                    <span className={styles.statIcon}>{s.icon}</span>
                    <strong className={styles.statNum}>{s.number}</strong>
                    <span className={styles.statLabel}>{s.label}</span>
                  </div>
                ))}
              </div>
            </Reveal> */}
          </div>
        </div>
      </section>

      {/* ── Values ────────────────────────── */}
      <section className={`${styles.section} ${styles.bgLight}`}>
        <div className={styles.container}>
          <Reveal>
            <div className={styles.sectionHead}>
              <span className={styles.label}>Our Values</span>
              <h2 className={styles.h2}>What Makes Us Different?</h2>
            </div>
          </Reveal>
          <div className={styles.valuesGrid}>
            {values.map((v, i) => (
              <Reveal key={i} delay={i * 100}>
                <div className={styles.valueCard}>
                  <span className={styles.valueIcon}>{v.icon}</span>
                  <h3 className={styles.valueTitle}>{v.title}</h3>
                  {/* <p className={styles.valueDesc}>{v.desc}</p> */}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ── What's New ────────────────────── */}
      {/* <section className={styles.section}>
        <div className={styles.container}>
          <Reveal>
            <div className={styles.sectionHead}>
              <span className={styles.label}>What's New</span>
              <h2 className={styles.h2}>When Reliable Technology Meets Real Patient Needs</h2>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div className={styles.newsCard}>
              <div className={styles.newsAccent} />
              <div className={styles.newsContent}>
                <span className={styles.newsTag}>Case Study</span>
                <h3 className={styles.newsTitle}>CT System Maintenance at Dessie Comprehensive Hospital</h3>
                <div className={styles.newsBody}>
                  <p>
                    At Dessie Comprehensive Hospital, the demand for CT services continues to grow
                    every day. Patients are traveling long distances because CT access in the region
                    is limited, making this equipment a lifeline for many.
                  </p>
                  <p>
                    The Medical Director, Dr. Haimanot, shares how essential CT services are for
                    specialized hospitals and how reliable equipment directly impacts patient care.
                  </p>
                  <p>
                    Following a comprehensive maintenance process, the CT system is now fully
                    serviced, with all necessary parts replaced, and is once again operating at
                    optimal performance — serving patients without interruption.
                  </p>
                </div>
                <div className={styles.newsQuote}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M11.3 5.8C6.5 7.3 4 10 4 14.1c.4-.1.8-.2 1.3-.2 2.2 0 3.9 1.6 3.9 3.9C9.2 20 7.6 21.5 5.5 21.5 3 21.5 1 19.3 1 16c0-5.8 3.8-10.4 10.3-12.2zm10 0C16.5 7.3 14 10 14 14.1c.4-.1.8-.2 1.3-.2 2.2 0 3.9 1.6 3.9 3.9 0 2.2-1.6 3.7-3.7 3.7-2.5 0-4.5-2.2-4.5-5.5 0-5.8 3.8-10.4 10.3-12.2z"/></svg>
                  This is what Infinity stands for: end-to-end healthcare solutions, helping hospitals
                  operate smoothly and ensuring patients receive timely, quality care.
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section> */}

      {/* ── Gallery ───────────────────────── */}
      {/* <section className={`${styles.section} ${styles.bgLight}`}>
        <div className={styles.container}>
          <Reveal>
            <div className={styles.sectionHead}>
              <span className={styles.label}>Operational evidence</span>
              <h2 className={styles.h2}>Proven Execution at scale</h2>
              <p>Infinity has delivered 100+ turnkey projects across Ethiopia's leading hospitals and universities, including 15+ MRI systems, 40+ CT scanners, and 5+ catheterization labs — all GE Healthcare equipment.</p>
            </div>
          </Reveal>
        </div>
        <ImageSlider />
      </section> */}

      {/* ── Partners ──────────────────────── */}
      {/* <section className={styles.section}>
        <div className={styles.container}>
          <Reveal>
            <div className={styles.sectionHead}>
              <span className={styles.label}>Our Partners</span>
              <h2 className={styles.h2}>Partnering with Global Leaders</h2>
              <p className={styles.subtext}>
                We work with leading global suppliers, healthcare innovators, and local institutions
                to shape the future of healthcare in East Africa.
              </p>
            </div>
          </Reveal>
        </div>
        <LogoSlider items={partners} />
      </section> */}
    </main>
  );
}
